import { isDemoActive } from "../demo/demoMode";

// Фото объявлений в переписке: адрес приводится к нужному размеру Kleinanzeigen
// и проводится через /api/messages/image (сервер берёт его как сообщения —
// напрямую или через прокси аккаунта). Общие для «Сообщений» и дашборда.

const MESSAGE_PREVIEW_RULE = "$_2.JPG";

export const normalizePreviewImageUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  // Нарисованные фото песочницы — только в демо; в настоящей панели data-адрес
  // означает заглушку площадки, а не снимок.
  if (/^data:/i.test(raw)) return isDemoActive() && /^data:image\//i.test(raw) ? raw : "";
  const normalizeRuleForKleinanzeigen = (parsed) => {
    const host = String(parsed.hostname || "").toLowerCase();
    const isProdAdsImage = host === "img.kleinanzeigen.de"
      && parsed.pathname.startsWith("/api/v1/prod-ads/images/");
    if (!isProdAdsImage) return parsed;
    // Превью здесь — квадратик 40–46 px в списке, в полосе объявления и на
    // дашборде. Брался самый крупный размер галереи ($_57: 200–300 КБ, до
    // 1600 px), и для аккаунта на своём прокси шёл через этот прокси. $_2 —
    // 200 px, ~12 КБ на том же снимке (замер 23.10.2026), с запасом и для
    // экранов с тройной плотностью. JPEG, а не .AUTO: на AUTO KL отдаёт AVIF,
    // который не открывают iPhone до iOS 16.
    parsed.searchParams.set("rule", MESSAGE_PREVIEW_RULE);
    return parsed;
  };
  if (/^(https?:)?\/\//i.test(raw)) {
    try {
      const parsed = normalizeRuleForKleinanzeigen(new URL(raw.startsWith("//") ? `https:${raw}` : raw));
      return parsed.href;
    } catch {
      return raw.startsWith("//") ? `https:${raw}` : raw;
    }
  }
  if (/^img\.kleinanzeigen\.de/i.test(raw)) return normalizePreviewImageUrl(`https://${raw}`);
  if (/^\/api\/v1\/prod-ads\/images\//i.test(raw)) return normalizePreviewImageUrl(`https://img.kleinanzeigen.de${raw}`);
  try {
    const parsed = normalizeRuleForKleinanzeigen(new URL(raw, "https://www.kleinanzeigen.de"));
    return parsed.href;
  } catch {
    return "";
  }
};

export const toMessageImageSrc = (value, accountId) => {
  const normalized = normalizePreviewImageUrl(value);
  if (!normalized) return "";
  const accountToken = accountId !== undefined && accountId !== null && String(accountId).trim()
    ? String(accountId).trim()
    : "";
  if (normalized.startsWith("/api/messages/image?")) {
    let src = normalized;
    if (accountToken && !/[?&]accountId=/i.test(src)) {
      const separator = src.includes("?") ? "&" : "?";
      src = `${src}${separator}accountId=${encodeURIComponent(accountToken)}`;
    }
    return src;
  }
  if (/^https?:\/\//i.test(normalized)) {
    if (!accountToken) return normalized;
    const params = new URLSearchParams();
    params.set("url", normalized);
    params.set("accountId", accountToken);
    return `/api/messages/image?${params.toString()}`;
  }
  return normalized;
};

export const getRawMessagePreviewImage = (message) => {
  if (!message || typeof message !== "object") return "";
  const candidates = [
    message.adImage,
    message.adImageUrl,
    message.adImageURL,
    message.imageUrl,
    message.image,
    message.thumbnailUrl,
    message.thumbnail,
    message.previewImage,
    message.ad?.image,
    message.ad?.imageUrl,
    message.ad?.thumbnailUrl
  ];
  for (const candidate of candidates) {
    const normalized = normalizePreviewImageUrl(candidate);
    if (normalized) return normalized;
  }
  return "";
};

export const getMessagePreviewImage = (message) =>
  toMessageImageSrc(getRawMessagePreviewImage(message), message?.accountId);

export const hasMessagePreviewImage = (message) => Boolean(getRawMessagePreviewImage(message));
